export enum ContentRatingMarksMultiplierEnum {
  ONE = "ONE",
  TWO = "TWO",
  FIVE = "FIVE",
  TEN = "TEN",
  TWENTY = "TWENTY",
  FIFTY = "FIFTY",
}
